import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterRecipientsPage = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/overview/recipients/index.page'),
);

function NewsletterRecipientsRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterRecipientsPage newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/recipients',
)({
  component: NewsletterRecipientsRoute,
});
